import { MetaData } from '../interfaces/meta-data.interface';
import { ReceiptAggregates } from '../interfaces/receipt-aggregates.interface';
import { ReportDTO } from '../dto/report.dto';
import { RevenuePerDay } from '../interfaces/revenue-per-day.interface';
import { Totals } from '../interfaces/totals.interface';

export class Report {
  public metaData?: MetaData;
  public receiptDayAggregates?: ReceiptAggregates;
  public revenuePerHour?: RevenuePerDay;
  public totals?: Totals;
  public receiptAggregates?: any;
  public revenue: any;

  public static fromDTO(reportDTO: ReportDTO): Report {
    const report: Report = new Report();

    report.metaData = reportDTO.metaData;

    if (
      reportDTO.receiptDayAggregates &&
      reportDTO.receiptDayAggregates.receiptAggregates
    ) {
      report.receiptDayAggregates =
        reportDTO.receiptDayAggregates.receiptAggregates;
    } else {
      delete report.receiptDayAggregates;
    }
    if (reportDTO.revenuePerHour) {
      report.revenuePerHour = reportDTO.revenuePerHour.revenuePerDay;
    } else {
      delete report.revenuePerHour;
    }
    if (reportDTO.totals) {
      report.totals = reportDTO.totals;
    } else {
      delete report.totals;
    }
    report.receiptAggregates = reportDTO.receiptAggregates;
    report.revenue = reportDTO.revenue;

    return report;
  }
}
